<template>
  <div id="chart">
    <v-container>
      <v-card class="pa-5" loading="true">
        <v-row justify="center">
          <h1 class="primary--text mt-1">รายงานประจำเดือนยอดบริการ</h1>
          <v-btn
            class="float-right ml-5 mt-0"
            color="#636262"
            text
            fab
            @click="openSetting()"
            v-if="mode"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-row>
        <v-row>
          <v-col cols="6">
            <apexchart
              type="line"
              height="350"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </v-col>
          <v-col cols="6">
            <apexchart
              type="line"
              height="350"
              :options="chartOptions_1"
              :series="series_1"
            ></apexchart>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <DialogChart
      class="vue"
      ref="dialog_chart_setting"
      @getChart="getChartReport()"
    ></DialogChart>
  </div>
</template>
<script>
import DialogChart from "../Settings/DialogChart.vue";
export default {
  components: {
    DialogChart,
  },
  data() {
    return {
      mode: false,
      all_chart_report: [],
      series: [],
      chartOptions: {
        colors: ["#FF8E1C"],
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        title: {
          text: "Total Case",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
        yaxis: {
          title: {
            text: "จำนวน (คน)",
          },
        },
      },
      series_1: [],
      chartOptions_1: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#f27091"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Emergency & Elective",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
        yaxis: {
          title: {
            text: "จำนวน (คน)",
          },
          // min: 5,
          // max: 100
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
    };
  },

  created() {
    this.mode = this.$session.get("token")
      ? this.$session.get("permission") == "admin"
      : false;
    this.getChartReport();
  },
  methods: {
    openSetting() {
      this.$refs.dialog_chart_setting.openSetting();
    },
    getChartReport() {
      let chart_report = [];
      this.series = [];
      this.series_1 = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/monthly_revice_report")
        .then((response) => {
          var date = new Date().toISOString().substr(0, 10);
          var month = date.split("-")[1];

          chart_report = response.data;
          this.all_chart_report = chart_report;
          var general_data = [];
          var emergency_data = [];
          var anesthesia_data = [];
          chart_report[0].data.forEach((element, index) => {
            if (index + 1 > parseInt(month) - 1) {
              element = null;
              general_data.push(element);
            } else {
              console.log(element);
              if (element == 0) {
                element = null;
                general_data.push(element);
              } else {
                general_data.push(element);
              }
            }
          });
          chart_report[1].data.forEach((element, index) => {
            if (index + 1 > parseInt(month) - 1) {
              element = null;
              emergency_data.push(element);
            } else {
              if (element == 0) {
                element = null;
                emergency_data.push(element);
              } else {
                emergency_data.push(element);
              }
            }
          });
          chart_report[2].data.forEach((element, index) => {
            if (index + 1 > parseInt(month) - 1) {
              element = null;
              anesthesia_data.push(element);
            } else {
              if (element == 0) {
                element = null;
                anesthesia_data.push(element);
              } else {
                anesthesia_data.push(element);
              }
            }
          });
          this.series.push({
            name: chart_report[0].monthly_service_reports_type_name,
            data: general_data,
          });

          this.series_1.push({
            name: chart_report[1].monthly_service_reports_type_name,
            data: emergency_data,
          });
          this.series_1.push({
            name: chart_report[2].monthly_service_reports_type_name,
            data: anesthesia_data,
          });
        });
    },
  },
};
</script>
